export const DEFAULT_PLANNER_TITLE = 'Untitled Planner';

export const CHARS =
  'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
export const DEVICE_ID_KEY = 'wwm_device_id';

export const MAX_PARTICIPANTS_NAME_LENGTH = 20;
export const MAX_PARTICIPANTS = 10;

export const MAX_TITLE_LENGTH = 50;
export const MAX_DAYS = 10;

export const INITIAL_START_HOURS = '09:00';
export const INITIAL_END_HOURS = '17:00';
